<template>
  <layout-page name="password" wide bg-image centered box>
    <router-view />
  </layout-page>
</template>

<script>
const routeGuard = (to, from, next) => {
  if (to.name === "password") {
    return next("/login");
  }

  return next();
};

export default {
  name: "PasswordPage",
  beforeRouteEnter: routeGuard,
  beforeRouteUpdate: routeGuard,
};
</script>

<style lang="scss"></style>
